import { DateTime } from "luxon";
import { useState } from "react";
import UserData from "../Controls/UserData";

export default function SkillBrief({ skillID, onEdit }) {
  const [userData] = useState(UserData.UserData());
  const skill = (userData?.skills || []).find((s) => s.ID === skillID);

  if (!skill || typeof skill !== "object") {
    console.error("SkillBrief received invalid skill data:", skill);
    return <div>Invalid skill data</div>;
  }

  const id = skill.ID || skill.id;

  return (
    <div className="mobileCard">
      <div className="header">
        Skill - {skill.ShortName === undefined ? skill.Name : skill.ShortName}
      </div>
      <div className="body">
        <div>
          <div className="label">Name: </div>
          <button
            type="button"
            className="skillLink skill-brief-edit"
            data-testid={id ? `skill-edit-${id}` : "skill-edit"}
            onClick={() => onEdit?.(id)}
          >
            {skill.Name}
          </button>
        </div>
        <div>
          <div className="label">Release Date: </div>
          {skill.ReleaseDate ? DateTime.fromISO(skill.ReleaseDate).toFormat("MM/yyyy") : "N/A"}
        </div>
        <div>
          <div className="label">Category: </div>
          {skill.CategoryName}
        </div>
        <div>
          <div className="label">Description: </div>
          {skill.Description}
        </div>
      </div>
    </div>
  );
}
